import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // Treat same as 403: do not redirect; show authorization message
          return throwError(() => ({ message: 'You are not authorised to do this action.', status: 401 }));
        }
        if (err.status === 403) {
          // Do not logout or navigate; surface a clear authorization message to UI
          return throwError(() => ({ message: 'You are not authorised to do this action.', status: 403 }));
        }
        if (err.status === 400 || err.status === 404 || err.status === 500) {
          // Generic admin contact message for common client/server errors
          return throwError(() => ({ 
            message: 'Something went wrong. Please contact the administrator.', 
            status: err.status 
          }));
        }
        // For all other errors (including 409), preserve the original error structure
        const error = err.error?.message || err.statusText;
        return throwError(() => ({ 
          message: error, 
          status: err.status,
          error: err.error 
        }));
      })
    );
  }
}


